<template>
  <div>
    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-5xl">
      <!-- Congratulations Success Alert -->
      <div class="rounded-md bg-green-100 shadow p-4 mb-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm sm:text-base font-medium text-green-800">
              Congratulations, your property qualifies for our protest service
            </p>
          </div>
        </div>
      </div>

      <div class="bg-white p-4 sm:p-6 shadow sm:rounded-lg">
        <div>

          <template v-if="ifEmailExists">
            <div class="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
              <div class="flex">
                <div class="flex-shrink-0">
                  <svg class="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                  </svg>
                </div>
                <div class="ml-3">
                  <h3 class="-mt-1 font-medium text-blue-800 mb-0.5">Please Sign in</h3>
                  <p class="text-sm text-blue-700">
                    You already have an account registered with this email address. Please Sign in.
                  </p>
                </div>
              </div>
            </div>
          </template>

          <label for="email" class="block text-sm font-medium text-gray-700">
            Best email address to receive legal notices:
          </label>
          <div class="mt-1">
            <div class="flex">
              <div class="flex rounded-md shadow-sm w-full relative">
                <input type="text" name="email" v-model="email" @keyup="checkEmailExists()" placeholder="Enter email" autofocus autocomplete="off" 
                class="placeholder:text-sm mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400">
                <div v-if="isSearching" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <svg class="h-5 w-5 text-gray-400 animate-spin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M304 48C304 74.51 282.5 96 256 96C229.5 96 208 74.51 208 48C208 21.49 229.5 0 256 0C282.5 0 304 21.49 304 48zM304 464C304 490.5 282.5 512 256 512C229.5 512 208 490.5 208 464C208 437.5 229.5 416 256 416C282.5 416 304 437.5 304 464zM0 256C0 229.5 21.49 208 48 208C74.51 208 96 229.5 96 256C96 282.5 74.51 304 48 304C21.49 304 0 282.5 0 256zM512 256C512 282.5 490.5 304 464 304C437.5 304 416 282.5 416 256C416 229.5 437.5 208 464 208C490.5 208 512 229.5 512 256zM74.98 437C56.23 418.3 56.23 387.9 74.98 369.1C93.73 350.4 124.1 350.4 142.9 369.1C161.6 387.9 161.6 418.3 142.9 437C124.1 455.8 93.73 455.8 74.98 437V437zM142.9 142.9C124.1 161.6 93.73 161.6 74.98 142.9C56.24 124.1 56.24 93.73 74.98 74.98C93.73 56.23 124.1 56.23 142.9 74.98C161.6 93.73 161.6 124.1 142.9 142.9zM369.1 369.1C387.9 350.4 418.3 350.4 437 369.1C455.8 387.9 455.8 418.3 437 437C418.3 455.8 387.9 455.8 369.1 437C350.4 418.3 350.4 387.9 369.1 369.1V369.1z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <small class="text-gray-500 italic text-xs">
            We will email you a 6 digit code to confirm your account. We respect your privacy. We will never share your contact information without your consent.
          </small>
        </div>

        <Registration v-if="showForm && !ifEmailExists" :account-number="accountNumber" :email="email" v-on:check-email-exists="checkEmailExists($event)" />

        <Login v-if="showForm && ifEmailExists" :account-number="accountNumber" :email="email" v-on:check-email-exists="checkEmailExists($event)" />
      </div>

    </div>
  </div>

</template>

<script>
import UserApi from "@/services/api/User.js";
import Registration from "./Registration.vue";
import Login from "./Login.vue";

export default {
  props: ["accountNumber", "property"],
  components: {
    Login,
    Registration,
  },

  data() {
    return {
      ifEmailExists: false,
      email: "",
      isSearching: false,
      showForm: false,
    };
  },

  methods: {
    checkEmailExists() {
      if (!this.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        this.ifEmailExists = false;
        this.showForm = false;
        return;
      }

      this.isSearching = true;
      UserApi.checkEmailExists(this.email)
        .then((res) => {
          this.ifEmailExists = res.data;
          this.isSearching = false;
          this.showForm = true;
        })
        .finally(() => window.unblockUI());
    },
  },
};
</script>

